import { BreakpointObserver } from '@angular/cdk/layout';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { APP_CONFIG, IAppConfig } from '../app.config';

@Injectable({
  providedIn: 'root'
})
export class ResponsiveDesignService {
  isSmallScreen$: Observable<boolean>

  constructor(
    private breakpointObserver: BreakpointObserver,
    @Inject(APP_CONFIG) private config: IAppConfig) {

    this.isSmallScreen$ = this.breakpointObserver.observe([this.config.smallScreenMediaQuery]).pipe(map(o => o.matches))
  }
}
